import type { ListBuilderList } from '../../../types';
import { createShopDefaultColumns } from '../columns';
import {
	SHOP_DEFAULT_REQUIRED_FIELDS,
	SHOP_MOBILE_CARD_CONFIG,
} from '../shared';

/**
 * Shop Default list configuration
 * All items available for purchase in the client shop
 */
export const shopDefaultList: ListBuilderList = {
	id: 'shop_default',
	cacheTTL: 600000,
	name: 'Shop Items',
	type: 'default',
	active: true,
	sortOrder: 0,
	columns: createShopDefaultColumns(),
	description: 'Items available for purchase in the client shop',
	defaultSortId: 'in_stock_first',
	requiredFields: SHOP_DEFAULT_REQUIRED_FIELDS,
	mobileCardConfig: SHOP_MOBILE_CARD_CONFIG,
};
